import { FC, useState } from 'react';
import { EmployedsFilterContainer } from './shared/EmployedsFilterContainer';
import { EmployedsFilterSection } from './shared/EmployedsFilterSection';
import { EmployedsFilterAmountRange } from './shared/EmployedsFilterAmountRange';
import styles from './shared/EmployedsFilterContainer.module.scss';

export interface PriceFilterProps {
  minValue?: number;
  maxValue?: number;
  onChange: (min?: number, max?: number) => void;
  onReset: () => void;
  onApply: () => void;
  show?: boolean;
}

export const EmployedsPriceFilter: FC<PriceFilterProps> = ({
  minValue,
  maxValue,
  onChange,
  show,
}) => {
  const [localMin, setLocalMin] = useState<string>(minValue?.toString() || '');
  const [localMax, setLocalMax] = useState<string>(maxValue?.toString() || '');

  const handleMinChange = (value: string | number) => {
    const stringValue = String(value);
    setLocalMin(stringValue);
    const numValue = stringValue === '' ? undefined : Number(stringValue);
    onChange(numValue, maxValue);
  };

  const handleMaxChange = (value: string | number) => {
    const stringValue = String(value);
    setLocalMax(stringValue);
    const numValue = stringValue === '' ? undefined : Number(stringValue);
    onChange(minValue, numValue);
  };

  return (
    <EmployedsFilterContainer className={styles.amount}>
      <EmployedsFilterSection>
        <EmployedsFilterAmountRange
          show={show}
          fromValue={localMin}
          toValue={localMax}
          onFromChange={handleMinChange}
          onToChange={handleMaxChange}
          fromPlaceholder='0'
          toPlaceholder='1 000 000'
          hideSearchIcon={true}
        />
      </EmployedsFilterSection>
    </EmployedsFilterContainer>
  );
};
